<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="选择Excel">
              <user-bank-batch-excel
                ref="userBankExcel"
                @getUserBatchDemo="getUserBatchDemo"
                @excelFileRemove="excelFileRemove"
                @change-file="(_) => this.file = _"
                @change="(_) => this.form.data = _"
              />
            </el-form-item>

            <el-form-item label="上传进度">
              <div style="margin-top: 8px">
                <el-progress v-if="percentage < 100"
                            :percentage="percentage"
                            :stroke-width="18"
                            color="#666666">
                </el-progress>
                <el-progress v-if="percentage === 100"
                            :percentage="100"
                            :stroke-width="18"
                            status="success">
                </el-progress>
              </div>
            </el-form-item>

            <el-form-item label="错误记录">
              <template>
                <div v-for="(item) in error_data">
                  <span>{{ item }}</span>
                </div>
              </template>
            </el-form-item>

          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">开始上传
          </el-button>
          <el-button @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import UserBankBatchExcel from '../components/UserBankBatchExcel.vue'

export default {
  components: {UserBankBatchExcel},
  data () {
    return {
      form: {
        data: [],
      },
      error_data: [],
      percentage: 0,
      file: null,
      fileHeader: [
        {
          key: 'user_name',
          text: '用户名'
        },
        {
          key: 'department_name',
          text: '部门'
        },
        {
          key: 'first_approver_name',
          text: '一级审批人'
        },
        {
          key: 'second_approver_name',
          text: '二级审批人'
        },
        {
          key: 'third_approver_name',
          text: '三级审批人'
        },
        {
          key: 'fourth_approver_name',
          text: '四级审批人'
        },
        {
          key: 'name',
          text: '账户名称'
        },
        {
          key: 'bank_account',
          text: '银行账号'
        },
        {
          key: 'bank',
          text: '开户银行支行'
        },
        {
          key: 'bank_headquarters',
          text: '开户银行总行'
        },
      ],
    }
  },
  computed: {},
  watch: {},
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...request.map([]),
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$refs.userBankExcel.$refs.userBankBatchExcel.clearFiles()
    },
    getUserBatchDemo () {
      let demo = [{
        'user_name': 'Ivys Chen',
        'department_name': '产品技术部',
        'first_approver_name': 'Yue Zhang',
        'second_approver_name': 'Irene Huang',
        'third_approver_name': 'Fenix',
        'fourth_approver_name': 'Sam Huang',
        'name': '张三',
        'bank_account': '60000000000000001',
        'bank': '工商银行上海金陵支行',
        'bank_headquarters': '中国工商银行总行',
      }, {
        'user_name': '*管理端账户名称',
        'department_name': '*建议以企微通讯录架构部门名称命名',
        'first_approver_name': '*管理端账户名称',
        'second_approver_name': '*管理端账户名称',
        'third_approver_name': '*管理端账户名称',
        'fourth_approver_name': '*管理端账户名称',
        'name': '*银行户名',
        'bank_account': '*注意使用文本格式',
        'bank': '*上传时请删除本说明行',
        'bank_headquarters': '*上传时请删除本说明行',
      }]
      this.$export('批量上传员工账户信息', demo, {fileHeader: this.fileHeader})
    },
    getFormData () {
      return filter.copyJson(this.form.data)
    },
    onSubmit () {
      if (this.form.data.length === 0) {
        this.$message.error('请选择文件')
      } else {
        this.create()
      }
    },
    excelFileRemove (fileList) {
      if (fileList.length === 0) {
        this.form.data = []
      }
    },
    async create () {
      let data = this.getFormData()
      this.error_data = []
      for (let index = 0; index < data.length; index++) {
        let param = data[index]
        let num = index + 1
        this.percentage = (num / data.length) * 100

        let info = '第' + num + '行 '
        if (this.checkParams(param, info)) {
          try {
            let api = 'batchCreateUserBankAccount'
            if (this.$route.meta.type === 'edit') {
              api = 'batchEditUserBankAccount'
            }
            await request.loading(api, param)
          } catch (error) {
            this.error_data.push(info + error.message)
          }
        }
      }
    },
    checkParams (param, info) {
      let err = ''
      let rule = {
        user_name: '用户名',
        department_name: '部门',
        first_approver_name: '一级审批人',
        second_approver_name: '二级审批人',
        third_approver_name: '三级审批人',
        fourth_approver_name: '四级审批人',
        name: '账户名称',
        bank_account: '银行账号',
        bank: '开户行',
      }

      for (const ruleKey in rule) {
        if (!param[ruleKey]) {
          err = rule[ruleKey] + ' 为空'
          break
        }
      }

      if (err) {
        this.error_data.push(info + err)
        return false
      }
      return true
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/user-bank-account/pages/UserBankBatchForm.vue